const connections = {};
const fire = function (channel, args) {
    const cnxs = connections[channel];
    if (cnxs) {
        for (let i = 0; i < cnxs.length; i++) {
            cnxs[i](args);
        }
    }
};
export default fire;
